<template>
  <div>
      <div class="footer">
        <ul>
          <li style="margin-bottom:0.68rem">
            <img src="../assets/images/footer_logo.png" alt="" style="width:2.07rem;height：0.45rem;padding-top:0.67rem;" v-if="$i18n.locale=='ch'">
             <img src="../assets/images/footer_logo2.png" alt="" style="width:1.88rem;height：0.3453rem;padding-top:0.67rem;" v-if="$i18n.locale=='en'">
          </li>
          <li style="margin-bottom:0.58rem">
            <span class="footer_item">{{ $t("footer.text1") }}</span>
            <a href="tel:86 755 8695 6559">{{ $t("footer.text2") }}</a>
          </li>
          <li style="margin-bottom:0.57rem">
            <span class="footer_item">{{ $t("footer.text3") }}</span>
            <a href="tel:86 755 8696 0615">{{ $t("footer.text4") }}</a>
          </li>
          <li style="margin-bottom:0.53rem">
            <span class="footer_item">{{ $t("footer.text5") }}</span>
            <a href="Mailto:business@vrviu.com">{{ $t("footer.text6") }}</a>
          </li>
          <li style="margin-bottom:0rem">
            <span class="footer_item" v-html="$t('footer.text7')" style="line-height:1.5em"></span>
          </li>
        </ul>
        <img class="sqcore_pic" src="../assets/images/sqcore.png" v-if="$i18n.locale=='ch'"></img>
      </div>
      <div class="copyright center" v-html="$t('footer.text8')">

      </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Bus from './bus.js';
import i18n from '../common/i18n'

export default {
  i18n:i18n,
  created(){
    var language = navigator.language; //取得浏览器版本语言
    var initLanguage = "";
    if(localStorage.locale){
      this.$i18n.locale = localStorage.locale;

    }else{
      if (language.indexOf('zh') > -1){
        initLanguage="ch"; //中文页面
      }else if (language.indexOf('en') > -1){
        initLanguage="en"; //英文页面
      }
      this.$i18n.locale = initLanguage;
    }
    self = this;
    Bus.$on('on-locale-change', target => {  
        self.$i18n.locale=target;
    });
  }
}
</script>

<style>
.english .foot_text{
    padding-top: 0.6rem!important;
}
.english .copyright{
  height: 1.4rem;
  padding-top: 0.3rem
}
.copyright{
  height: 2.2rem;
  background:#1A1A1A;
  font-size: 0.22rem;
  color:#454545;
  line-height: 0.4rem;
}
.sqcore_pic{
  display: inline-block;
  width: 1.55rem;
  height: 1.79rem;
  /*background:url(../assets/images/sqcore.png) no-repeat;*/
  /*background-size: cover;*/
  position: absolute;
  right: 0.56rem;
  bottom: 1.69rem;
}
.footer li,.footer span{
  line-height: 0;
}
.footer ul{
  padding-bottom: 0.7rem;
}
.footer li{
  margin-bottom: 0.67rem;
}
.footer{
  background-color: #212121;
  position: relative;
  padding-left: 0.34rem;
}
.footer_item{
  font-size: 0.24rem;
  color: #686868;
  vertical-align: middle;
}
.footer li{
  font-size: 0.28rem;
  color:#afafaf;
  line-height: 0.28rem;
  vertical-align: middle;
}
.footer li a{
  color:#afafaf;
}
</style>



// WEBPACK FOOTER //
// footer.vue?ab5304de